// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/core-js/modules/es7.map.of.js
// module id = ../../node_modules/core-js/modules/es7.map.of.js
// module chunks = 18